import React from "react";

export const WatchlistIcon: React.FC = () => (
  <svg width={347.04} height={397.01} viewBox="0 0 347.04 397.01">
    <path
      d="M31.57,.23C14.13,.24,0,11.42,0,25.2L.04,369c0,32,43,41,82,2l84-90c6-6,10-6,15-1l79,88c40,44,87,33,86.46-.1l.54-342.88C347.07,11.2,332.89-.01,315.4,0L31.57,.23ZM309.75,52.64l-.51,275.97c-.2,23.39,.8,39.39-16.2,23.39l-102-112c-10-12-24-13-34.75-1.14l-97.25,105.14c-22,23-22,12-21.75-12.81V52.82c0-13.09,7.21-18.71,23.78-18.72l224.85-.22c16.61-.01,23.87,5.64,23.84,18.76Z"
      fill="#1b3c55"
    />
  </svg>
);
